function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Search({
  width = 20,
  height = 20,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.11 18.746l-4.577-4.481a8.271 8.271 0 00.222-11.568C11.67-.596 6.499-.916 3.02 1.971a8.275 8.275 0 00-1.252 11.505c2.779 3.546 7.902 4.31 11.624 1.735l4.668 4.593c.292.268.749.26 1.032-.018a.723.723 0 00.018-1.016v-.024zM1.617 8.414c0-3.77 3.106-6.826 6.937-6.826 3.83 0 6.936 3.056 6.936 6.826 0 3.77-3.106 6.826-6.936 6.826-3.831 0-6.937-3.056-6.937-6.826z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Search.js.map